export default __webpack_public_path__ + "static/media/photo--sm--60.67441184.jpg";